import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1udwajl633: FaireBrandEntity = {
  token: "b_1udwajl633",
  type: "brand",
  name: "Ladivine by Cinderella Divine",
  avatarUrl:
    "https://cdn.faire.com/fastly/52f5de42935fef2736414edf7e73137618a8568c044cf136d45c6891b3950192.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ffb1d30c426628825c2792680a902bfd23a918da5077825927b6ccd67108f82a.png",
  logoUrl:
    "https://cdn.faire.com/fastly/52f5de42935fef2736414edf7e73137618a8568c044cf136d45c6891b3950192.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ffb1d30c426628825c2792680a902bfd23a918da5077825927b6ccd67108f82a.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 208,
  rating: 4.8,
  reviewCount: 294,
  isTopShop: true,
  isInsider: true,
  description:
    "Ladivine by Cinderella Divine is a premier designer of formal gowns for prom, wedding, mother of the bride, homecoming, cocktail dresses, and other special occasions dresses. Our headquarter and distribution center is conveniently located in Los Angeles, CA and our office operates on PST. Since 2006, Cinderella Divine has serviced over 5000 boutiques worldwide with eye-catching designs with high trend sensibility. We have built our reputation as a leader in the prom industry, offering a wide arrange of merchandise with exceptional quality at a competitive price point. With a strong inventory base and fresh collections launching throughout the year, Cinderella Divine is dedicated to providing the ultimate shopping experience for our retailers.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:34.817Z",
    importedBy: "entity-db-cli",
  },
};
